import React from 'react';
import PropTypes from 'prop-types';
import SystemMessage from '../SystemMessage';
import SystemMessageText from '../SystemMessageText';
import SystemMessageLink from '../SystemMessageLink';
import { storeLocalObject, readLocalObject } from './SystemMessageStorage';

class SystemMessageCookie extends React.Component {
  componentDidMount() {
    storeLocalObject();
  }

  render() {
    const { message, link } = this.props;
    if (readLocalObject()) {
      return null;
    }
    return (
      <SystemMessage classModifier="system-message-wrapper--cookie">
        <SystemMessageText message={message} />
        {link && <SystemMessageLink link={link} text="Så använder vi cookies" />}
      </SystemMessage>
    );
  }
}

SystemMessageCookie.propTypes = {
  message: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default SystemMessageCookie;
